exports = module.exports = require("../../../../../../legacy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#mbl_btn_contact_phone[data-v-6472480f] {\n  padding-right: 25%;\n}", ""]);

// exports
